import { Record } from 'immutable';
import { getOr, remove } from 'lodash/fp';
import * as types from './actionTypes';
import constants from '../constants';

// export default util.requestReducer(CURRENT_USER);

const requestReducerState = Record({
  users: [],
  user: {
    id: null,
    dealer_id: null,
  },
  currentUser: null,
  currentUserDealer: {},
  currentUserDealers: [],
  [constants.ERROR_KEY]: null,
  [constants.FETCHING_KEY]: false,
});

const userReducer = (state = requestReducerState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case types.USERS_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('users', getOr(payload, 'data')(payload));
    case types.CURRENT_USER_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('currentUser', payload);
    case types.CURRENT_USER_DEALER_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('currentUserDealer', payload);
    case types.CURRENT_USER_DEALERS_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('currentUserDealers', payload);
    case types.USER_SUCCESS:
    case types.CREATE_USER_SUCCESS:
    case types.UPDATE_USER_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('user', payload);
    case types.UPDATE_USER_DEALERS_SUCCESS:
    case types.UPDATE_USER_PASSWORD_SUCCESS:
    case types.UNLOCK_USER_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false);
    case types.DELETE_USER_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('users', remove({ id: payload })(state.users));
    case types.CURRENT_USER_REQUEST:
    case types.CURRENT_USER_DEALER_REQUEST:
    case types.USERS_REQUEST:
    case types.USER_REQUEST:
    case types.CREATE_USER_REQUEST:
    case types.UPDATE_USER_REQUEST:
    case types.UPDATE_USER_PASSWORD_REQUEST:
    case types.UNLOCK_USER_REQUEST:
    case types.DELETE_USER_REQUEST:
    case types.UPDATE_USER_DEALERS_REQUEST:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, true);
    case types.CURRENT_USER_FAILURE:
    case types.CURRENT_USER_DEALER_FAILURE:
    case types.USERS_FAILURE:
    case types.USER_FAILURE:
    case types.CREATE_USER_FAILURE:
    case types.UPDATE_USER_FAILURE:
    case types.UNLOCK_USER_FAILURE:
    case types.UPDATE_USER_PASSWORD_FAILURE:
    case types.DELETE_USER_FAILURE:
    case types.UPDATE_USER_DEALERS_FAILURE:
      return state
        .set(constants.FETCHING_KEY, false)
        .set(constants.ERROR_KEY, action.payload);
    case types.RESET_USER:
      return state.set('user', {
        ...requestReducerState().user,
        dealer_id: action.payload,
      });
    case types.LOGOUT_USER:
      return state.set('currentUser', null).set('currentUserDealer', {});
    default:
      return state;
  }
};

export default userReducer;
